import { render, staticRenderFns } from "./MenuModels.vue?vue&type=template&id=1c303dbf"
import script from "./MenuModels.vue?vue&type=script&lang=js"
export * from "./MenuModels.vue?vue&type=script&lang=js"
import style0 from "./MenuModels.vue?vue&type=style&index=0&id=1c303dbf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports